import { fetchStoreProducts } from 'common/services/channel'
import { StoreProducts } from 'common/types/entities/store'
import { Sort } from 'common/constants'
import { StateKey } from 'common/utils/flipState'
import ProductTabType from 'common/constants/product/productTab'
import { fetchZzimedProducts } from 'common/services/zzim'
import { ArrayUtils } from '@shopping/common'
import { getVisibleGifProducts } from 'common/types/entities/mongo/product'
import history, { HistoryStateKey } from 'common/history'

const initialState: StoreProducts = {
  hasMoreProducts: false,
  products: [],
  page: 0,
  itemCount: 0,
  productNo: undefined,
  tabId: undefined,
}

const FETCH_STACKED = 'store/products/FETCH_STACKED'

export interface StoreProductParam {
  curState: StateKey
  storeId: string
  page: number
  pageSize: number
  sort?: Sort
  categoryId?: number
  includeZzim?: boolean
  brandId?: number
  includeItemCount?: boolean
  filterSoldOut?: boolean
  tabId?: ProductTabType
  headers?: any
}

export const fetchStackedProducts = (param: StoreProductParam) => async (dispatch, getState) => {
  const {
    curState,
    storeId,
    page,
    pageSize,
    sort,
    categoryId,
    includeZzim,
    brandId,
    includeItemCount,
    filterSoldOut,
    tabId,
    headers,
  } = param
  let storeProduct
  const restoredStoreProducts = getStoreProductsFromHistoryState()
  if (restoredStoreProducts) {
    storeProduct = restoredStoreProducts
  } else {
    storeProduct = await fetchStoreProducts(
      storeId,
      page,
      pageSize,
      sort,
      categoryId,
      brandId,
      includeItemCount,
      filterSoldOut,
    )
  }

  if (storeProduct && ArrayUtils.isNotEmpty(storeProduct.products)) {
    if (includeZzim) {
      const zzimProducts = await fetchZzimedProducts(storeProduct.products.map(product => product._id), headers)
      if (zzimProducts) {
        storeProduct.products.forEach(product => {
          const zzim = zzimProducts && zzimProducts[product._id]
          product.zzimCount = zzim && zzim.count
          product.isMyZzim = (zzim && zzim.zzim) || false
        })
      }
    }
    storeProduct.products = getVisibleGifProducts(storeProduct.products, getState().subVertical)
  }

  dispatch({
    curState,
    page,
    tabId,
    pageSize,
    type: FETCH_STACKED,
    payload: storeProduct || initialState,
  })
}

const getStoreProductsFromHistoryState = (): StoreProducts => {
  if (
    history.location &&
    history.location.state &&
    history.location.state[HistoryStateKey.STACKED_STORE_PRODUCTS_STATE]
  ) {
    const storeProducts = {
      ...history.location.state[HistoryStateKey.STACKED_STORE_PRODUCTS_STATE],
    }
    history.location.state = {
      ...history.location.state,
      [HistoryStateKey.STACKED_STORE_PRODUCTS_STATE]: null,
    }
    return storeProducts
  }
}

const productsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_STACKED:
      const products = action.page === 1 ? action.payload.products : [...state.products, ...action.payload.products]
      const itemCount = action.page === 1 ? action.payload.itemCount : state.itemCount
      return {
        products,
        itemCount,
        hasMoreProducts: action.payload.hasMoreProducts,
        page: action.page,
        pageSize: action.pageSize,
        tabId: action.tabId,
      }
    default:
      return state
  }
}

export default productsReducer
